const LanguageOptions = {
  en: "English",
  de: "Deutsch",
  es: "Español",
  fr: "Français",
  ko: "한국어",
  it: "Italiano",
  pt: "Português",
  tl: "Tagalog",
  zh: "中文",
  ja: "日本語",
};

export default LanguageOptions;
